module.exports = __webpack_public_path__ + "img/packageingDevice7.236520ad.png";